import {MinLength, ValidationOptions} from 'class-validator';

export function MyMinLength(max: number, validationOptions: ValidationOptions = {}) {
  const options = Object.assign({message: `Minimum length is ${max} symbols`}, validationOptions);
  return MinLength(max, options);
}
